// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_sensory_test_type */
var FoodSensoryTestType;
(function (FoodSensoryTestType) {
    FoodSensoryTestType["hedonic"] = "hedonic";
    FoodSensoryTestType["comparative"] = "comparative";
    FoodSensoryTestType["general"] = "general";
})(FoodSensoryTestType || (FoodSensoryTestType = {}));
;
export default FoodSensoryTestType;
/** Zod schema for food_sensory_test_type */
export const foodSensoryTestType = z.nativeEnum(FoodSensoryTestType);
//# sourceMappingURL=FoodSensoryTestType.js.map